import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

/**
 * fetch autenticato che restituisce direttamente `data` della ApiResponse.
 * Su 401/403 delega ad handleApiError (refresh/logout) e lancia con il messaggio del server.
 */
export function useApi() {
  const { getToken, handleApiError } = useAuth();

  return useCallback(
    async (path: string, options: RequestInit = {}): Promise<any> => {
      const token = getToken();
      const res = await fetch(`${API_BASE_URL}${path}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(options.headers || {}),
        },
      });

      if (!res.ok) {
        let message = `Errore ${res.status}`;
        try {
          const j = await res.json();
          message = j?.message || message;
        } catch {
          /* body non JSON */
        }
        if (res.status === 401 || res.status === 403) handleApiError(res);
        throw new Error(message);
      }

      if (res.status === 204) return null;
      const json = await res.json();
      return json?.data !== undefined ? json.data : json;
    },
    [getToken, handleApiError]
  );
}
